import { useListView } from '../../core/ListViewProvider'
import { SetorClienteListGrouping } from './SetorClienteListGrouping'
import { SetorClienteListSearchComponent } from './SetorClienteListSearchComponent'
import { SetorClienteListToolbar } from './SetorClienteListToolbar'

const SetorClienteListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <SetorClienteListSearchComponent
        actions={selected.length > 0 ? <SetorClienteListGrouping /> : <SetorClienteListToolbar />}
      />
    </div>
  )
}

export { SetorClienteListHeader }
